import type { CustomFile } from '../../types';

export function isFileValid(file: CustomFile) {
  return !(
    file.extensionError ||
    file.emptyFileError ||
    file.fileSizeExceededError ||
    file.uploadError
  );
}
